import { NavLink } from 'react-router-dom';
import { useStore } from '../../app/stores/store';
import { nativeNavigation } from '../../app/layout/nativeNavigation';
import { getCachedFitmentCatalogLabel } from '../../app/utils/fitmentCatalogLabel';
import { isProductGuideEnabledForCurrentContext } from '../../app/utils/productGuideFeature';
import { isServiceBookingEnabledForShop } from '../../app/utils/serviceBookingFeature';
import { observer } from 'mobx-react-lite';
import './LegacyTopNav.css';

export default observer(function OperatorNavigation() {
  const { userStore } = useStore();
  if (!userStore.user?.impersonation) return null;
  const shop = userStore.user.shopDomain;
  return <nav aria-label="Merchant app navigation" className="LegacyTopNav"><ul className="LegacyTopNav__list">
    {nativeNavigation(getCachedFitmentCatalogLabel(), isProductGuideEnabledForCurrentContext(shop), isServiceBookingEnabledForShop(shop)).map(link =>
      <li key={link.to} className="LegacyTopNav__item"><NavLink to={link.to}
        className={({ isActive }) => `LegacyTopNav__link${isActive ? ' LegacyTopNav__link--active' : ''}`}>{link.label}</NavLink></li>)}
  </ul></nav>;
});
